import Slider from './Slider'

export default Slider


// WEBPACK FOOTER //
// ./src/components/Slider/index.js